import type { Components } from '@mui/material/styles';

export default function MuiFormGroup(): Components['MuiFormGroup'] {
  return {};
}
